import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import FilterConcessionaire from 'views/teacher/concessionaire/filterConcessionaire'; // Importing filter component
import TableConcessionaire from 'views/teacher/concessionaire/tableConcessionaire'; // Importing table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the concessionaire view.
 * @extends JetView
 */
export default class concessionaireView extends JetView {
    /**
     * Configures the layout of the concessionaire view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration
        const right = {}; // Placeholder for right-side components (not used in this fragment)

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false,
                    height: 35,
                    size: 15, // Number of items per page
                },
            ],
        };

        // Left-side layout configuration
        const left = {
            container: 'layout_div', // Container for the left layout
            Width: 250, // Width of the left layout
            responsiveCell: false, // Responsive behavior
            css: 'left', // CSS class for styling
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left layout
                    css: theme, // Apply current theme
                    elements: [
                        {
                            view: 'label', // Label for the toolbar
                            label: _('Concesionario'), // Localized label text
                            width: 160, // Width of the label
                        },
                    ],
                },
                FilterConcessionaire, // Filter component
                TableConcessionaire, // Table component
                toolbar, // Toolbar component
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        // Return the main layout configuration
        return {
            type: 'wide', // Layout type
            responsive: true, // Enable responsive behavior
            css: 'out', // CSS class for styling
            cols: [
                left, // Left layout
                { view: 'resizer' }, // Resizer between left and right layouts
            ],
        };
    }
}

// FILE DOCUMENTED
